/**
 * Medidas del Gantt que comparten la cabecera y las filas.
 *
 * `INFO_COL_WIDTH` vivía dentro de `GanttRow`, y `GanttTrackHeader` la importaba
 * **desde una fila** para poder alinear sus columnas. Era al revés de lo que debe
 * ser: una constante de layout no puede depender de uno de los dos que la usan.
 */

/** Ancho del panel de información de la izquierda, en el Gantt de producción.
 *  Cabecera y filas tienen que usar el mismo o las columnas se descuadran. */
export const INFO_COL_WIDTH = 280
